export enum WSMessageHandler {
  BASE_LOCKER = 'BaseLocker',
  JOINED_LOCKER = 'JoinedLocker',
  MATRIX_LOCKER = 'MatrixLocker',
  CHECKTREE_LOCKER = 'CheckTreeLocker',
}
